import script from "./ChatList.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatList.vue?vue&type=script&setup=true&lang=js"

import "./ChatList.vue?vue&type=style&index=0&id=342f4a12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-342f4a12"]])

export default __exports__